import { MatchCardScores } from "../match_card_scores";
import { MatchCardShortlistButtonWrapper } from "../match_card_shortlist_button";
import css from "./match_card_header.module.scss";
import { MatchProfileInfo } from "./match_profile_info";
import { MatchStatusIcons } from "./match_status_icons";

export const MatchCardHeader = () => (
  <div className={css.header}>
    <div className={css.matchStatus}>
      <MatchCardScores />
      <MatchStatusIcons />
    </div>
    <div className={css.matchProfile}>
      <MatchProfileInfo />
      <div className={css.matchProfileActions}>
        <MatchCardShortlistButtonWrapper />
      </div>
    </div>
  </div>
);
